/**
 * Convert a string to a URL-friendly slug
 * Examples:
 * - "Red 40" -> "red-40"
 * - "Mono and Diglycerides" -> "mono-and-diglycerides"
 * - "Polysorbate 80" -> "polysorbate-80"
 */
export const slugify = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars except hyphens
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};

/**
 * Convert a slug back to a display name
 * Examples:
 * - "red-40" -> "red 40"
 * - "mono-and-diglycerides" -> "mono and diglycerides"
 */
export const unslugify = (slug: string): string => {
  return slug.replace(/-/g, ' ');
};
